
export const SET_APPROVERCOMMENT = `SET_APPROVERCOMMENT`;


export const setApproverComment = (data) => ({
    type: SET_APPROVERCOMMENT,
    value: data
});









